import type { CstElement, CstNode, IToken } from 'chevrotain';
import {
  StardogSparqlParser,
  isCstNode,
  isIToken,
  sparqlTokens as untypedSparqlTokens,
} from 'millan';
import type * as SparqlTokens from 'millan/dist/types/sparql/tokens';

export class ChainableSparqlCst {
  current: CstNode | undefined;

  constructor(cstNode: CstNode | undefined) {
    if (cstNode) {
      this.current = cstNode;
    }
  }

  getFirstCstNode(ruleName: keyof StardogSparqlParser) {
    const firstElement = this.getCstElements(ruleName)?.[0];
    if (firstElement && isCstNode(firstElement)) {
      this.current = firstElement;
    } else {
      this.current = undefined;
    }
    return this;
  }

  getFirstToken(tokenName: string): IToken | undefined {
    const firstElement = this.getCstElements(tokenName)?.[0];
    if (firstElement && isIToken(firstElement)) {
      return firstElement;
    }
    return undefined;
  }

  getCstElements(name: string): CstElement[] | undefined {
    return this.current?.children[name];
  }
}

export const sparqlTokens = untypedSparqlTokens as typeof SparqlTokens;
